import { Injectable } from '@angular/core';
import { MODELS_BY_BRAND_URL } from '../../shared/constants/urls';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CustomStorageService } from '../custom-storage/custom-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ModelsService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    authorization: 'bearer ' + this.storageService.getToken(),
  });

  constructor(private readonly client: HttpClient,
    private readonly storageService: CustomStorageService) { }

  getModelsByBrand(id: string) {
    return this.client.get(MODELS_BY_BRAND_URL + id , { headers: this.headers });
  }
}
